(() => {
  'use strict';
  function setupCatalog(root) {
    if (root.dataset.wgReady) return;
    root.dataset.wgReady = 'true';
    let selected = 'all';
    const search = root.querySelector('[data-wg-search]');
    const cards = [...root.querySelectorAll('[data-wg-card]')];
    const filters = [...root.querySelectorAll('[data-wg-filter]')];
    const result = root.querySelector('[data-wg-results]');
    const empty = root.querySelector('[data-wg-empty]');
    function update() {
      const query = (search?.value || '').trim().toLowerCase();
      let count = 0;
      for (const card of cards) {
        const matches = (selected === 'all' || card.dataset.group === selected) && card.dataset.title.toLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) count += 1;
      }
      for (const filter of filters) {
        const active = filter.dataset.wgFilter === selected;
        filter.classList.toggle('active', active);
        filter.setAttribute('aria-pressed', String(active));
      }
      if (empty) empty.hidden = count > 0;
      if (result) result.textContent = count + ' ' + root.dataset.resultsLabel;
    }
    root.addEventListener('click', event => {
      const filter = event.target.closest('[data-wg-filter]');
      if (!filter) return;
      selected = filter.dataset.wgFilter;
      update();
    });
    search?.addEventListener('input', update);
    document.querySelectorAll('[data-wg-collection]').forEach(link => link.addEventListener('click', () => {
      selected = link.dataset.wgCollection;
      if (search) search.value = '';
      update();
    }));
    update();
  }
  function setupProduct(root) {
    if (root.dataset.wgReady) return;
    root.dataset.wgReady = 'true';
    const select = root.querySelector('[data-wg-variant]');
    const data = root.querySelector('[data-wg-variant-data]');
    if (!select || !data) return;
    const variants = JSON.parse(data.textContent);
    select.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      root.querySelector('[data-wg-price]').textContent = variant.price;
      const add = root.querySelector('[data-wg-add]');
      add.disabled = !variant.available;
      add.textContent = variant.available ? root.dataset.addLabel : root.dataset.unavailableLabel;
    });
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-wg-catalog]').forEach(setupCatalog);
    scope.querySelectorAll('[data-wg-product]').forEach(setupProduct);
  }
  document.addEventListener('DOMContentLoaded', () => setup());
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
